export default __webpack_public_path__ + "static/char-s-32-zh-Hant-6a391117f635a0bb7ef21804edfe2b1e.webp";